import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Shield, Truck, RotateCcw, Clock } from "lucide-react";
import { api } from "@/lib/api";

export default function Footer() {
  const [contact, setContact] = useState({
    contact_email: "hello@vip77.store",
    contact_phone: "+7 (499) 777-77-77",
    working_hours_start: 10,
    working_hours_end: 20,
  });

  useEffect(() => {
    api.get("/settings").then((r) => setContact({
      contact_email: r.data.contact_email || "hello@vip77.store",
      contact_phone: r.data.contact_phone || "+7 (499) 777-77-77",
      working_hours_start: r.data.working_hours_start ?? 10,
      working_hours_end: r.data.working_hours_end ?? 20,
    })).catch(() => {});
  }, []);

  const workHoursLabel = `Ежедневно, ${String(contact.working_hours_start).padStart(2, "0")}:00–${String(contact.working_hours_end).padStart(2, "0")}:00`;

  return (
    <footer className="mt-24 border-t border-line bg-white" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 py-14 lg:px-8">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
          <div>
            <div className="mb-4 flex items-center gap-2">
              <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-ink text-white">
                <span className="font-extrabold tracking-tightest text-sm">V</span>
              </div>
              <div className="leading-none">
                <div className="font-extrabold tracking-tightest text-ink">vip77</div>
                <div className="text-[10px] uppercase tracking-[0.24em] text-muted-soft">store</div>
              </div>
            </div>
            <p className="text-sm leading-relaxed text-muted">
              Премиальная техника Apple и электроника. Оригинал, гарантия, бережная доставка по России.
            </p>
          </div>
          <div>
            <h4 className="mb-4 text-xs font-bold uppercase tracking-[0.2em] text-muted-soft">Каталог</h4>
            <ul className="space-y-2 text-sm text-ink">
              <li><Link to="/catalog/iphone" className="hover:underline">iPhone</Link></li>
              <li><Link to="/catalog/mac" className="hover:underline">Mac</Link></li>
              <li><Link to="/catalog/ipad" className="hover:underline">iPad</Link></li>
              <li><Link to="/catalog/watch" className="hover:underline">Apple Watch</Link></li>
              <li><Link to="/catalog/airpods" className="hover:underline">AirPods</Link></li>
              <li><Link to="/catalog/dyson" className="hover:underline">Dyson</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="mb-4 text-xs font-bold uppercase tracking-[0.2em] text-muted-soft">Компания</h4>
            <ul className="space-y-2 text-sm text-ink">
              <li><Link to="/account" className="hover:underline">Личный кабинет</Link></li>
              <li><Link to="/wishlist" className="hover:underline">Избранное</Link></li>
              <li><Link to="/compare" className="hover:underline">Сравнение</Link></li>
              <li><a href={`mailto:${contact.contact_email}`} className="hover:underline">{contact.contact_email}</a></li>
              <li><a href={`tel:${contact.contact_phone.replace(/[^\d+]/g, "")}`} className="hover:underline">{contact.contact_phone}</a></li>
            </ul>
          </div>
          <div>
            <h4 className="mb-4 text-xs font-bold uppercase tracking-[0.2em] text-muted-soft">Гарантии</h4>
            <ul className="space-y-3 text-sm text-ink">
              <li className="flex items-center gap-2"><Shield size={16} /> Оригинал 100%</li>
              <li className="flex items-center gap-2"><Truck size={16} /> Доставка по РФ</li>
              <li className="flex items-center gap-2"><RotateCcw size={16} /> Возврат 14 дней</li>
              <li className="flex items-center gap-2"><Clock size={16} /> {workHoursLabel}</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-line pt-6 text-xs text-muted md:flex-row md:items-center">
          <p>© {new Date().getFullYear()} vip77.store. Все права защищены.</p>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <Link to="/privacy-policy" className="hover:underline">Политика конфиденциальности</Link>
            <Link to="/consent" className="hover:underline">Согласие на обработку данных</Link>
            <Link to="/requisites" className="hover:underline">Реквизиты</Link>
          </div>
          <p>Не является официальным дистрибьютором Apple Inc.</p>
        </div>
      </div>
    </footer>
  );
}
